"use client";

import { useEffect, useMemo } from "react";
import { useAutoSave } from "@/features/lomdaEditorV2/hooks/useAutoSave";
import {
    useAssets,
    useChapters,
    useIdentity,
    useLomdaName,
    useMetadata,
    useScenesList,
    useUiActions,
} from "./hooks";

/**
 * Drives the debounced autosave from document-store state and mirrors the
 * resulting save status back into the UI slice. Renders nothing. Mounted once
 * inside the provider; a no-op in readOnly mode (thumbnails/render route).
 */
export function StoreAutoSave() {
    const { lomdaId, readOnly } = useIdentity();
    const scenes = useScenesList();
    const chapters = useChapters();
    const metadata = useMetadata();
    const lomdaName = useLomdaName();
    const assets = useAssets();
    const { setSaveStatus } = useUiActions();

    const content = useMemo(() => ({ scenes, chapters }), [scenes, chapters]);

    const { setLomdaData, saveLomda, isSaving, saveError, lastSaved } =
        useAutoSave({ lomdaId });

    useEffect(() => {
        if (readOnly) return;
        setLomdaData({ metadata, content, name: lomdaName, assets });
        saveLomda();
    }, [readOnly, metadata, content, lomdaName, assets, setLomdaData, saveLomda]);

    useEffect(() => {
        setSaveStatus({ isSaving, saveError, lastSaved });
    }, [isSaving, saveError, lastSaved, setSaveStatus]);

    return null;
}
